<template>
  <div class="ask-atto">
    <h5 class="title">Work in Progress</h5>
    <p class="body">Bear with us while we continue to develop and roll out the Diaceutics and DXRX brands.</p>

    <div class="any-questions">
      <i class="icon icon--bob"></i>
      <p class="text">Any questions? <a href="mailto:info@attopartners.com">Ask Atto.</a></p>
    </div>
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>
  .ask-atto {
    background: rgba(#3672FF, 0.3);
    padding: 20px;

    .title,
    .body {
      font-family: var(--f-bold);
      color: var(--text-dark);
      font-size: 0.75em;
      line-height: 1.66;
    }

    .body {
      font-family: var(--f-regular);
      margin-bottom: 12px;
    }

    .any-questions {
      display: flex;
      align-items: center;

      .icon--bob {
        display: inline-block;
        width: 17px;
        height: 26px;
        background: url('../assets/images/icons/icon--bob.svg') no-repeat center;
        background-size: contain;
      }

      .text {
        font-family: var(--f-bold);
        color: var(--text-dark);
        font-size: 0.75em;
        line-height: 1.66;
        padding-left: 12px;
        
        a {
          font-family: var(--f-regular);
          position: relative;

          &::after {
            content: '';
            display: block;
            position: absolute;
            top: 120%;
            left: 0;
            right: 0;
            width: 100%;
            height: 2px;
            background-color: #fff;
          }
        }
      }
    }
  }
</style>